import "./index.css";

import React from "react";
import { createRoot } from "react-dom/client";

import { Routes } from "./utils/routes/react-router-lazy";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>
);
